export default __webpack_public_path__ + "static/media/hidroponia.b1dbef14.PNG";